import OrderForm from './OrderForm'

export default OrderForm



// WEBPACK FOOTER //
// ./src/components/Orders/Form/index.js